import { WizardPanelTypes } from './wizard-panel-types';

export const WizardExtraPanels: Map<string, WizardPanelTypes> = new Map([
    ['VLU', WizardPanelTypes.UAV_CONFIGURATION],
    ['PCU', WizardPanelTypes.POINTCLOUD_CONFIGURATION],
    ['OBJU', WizardPanelTypes.OBJ_MODEL_3D_CONVERTER_CONFIGURATION],
    ['GISU', WizardPanelTypes.GIS_IMPORTER_CONFIGURATION],
    ['GCP', WizardPanelTypes.GIS_IMPORTER_CONFIGURATION],
]);
